import { Box, Button, Typography } from '@mui/material';
import React, { useState } from 'react';
import Coverage from '../../interfaces/coverage';
import BulkApproveCoverageModal from '../modals/bulkApproveCoverageModal';
import BulkRejectCoverageModal from '../modals/bulkRejectCoverageModal';
import BulkDeleteCoverageModal from '../modals/bulkDeleteCoverageModal';

interface CoverageGridActionsProps {
    selectedCoverages: Coverage[];
    onSuccess: () => void;
}

const CoverageGridActions: React.FC<CoverageGridActionsProps> = ({ selectedCoverages, onSuccess }) => {
    const [approveModalOpen, setApproveModalOpen] = useState<boolean>(false);
    const [rejectModalOpen, setRejectModalOpen] = useState<boolean>(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState<boolean>(false);

    return (
        <Box display="flex" justifyContent="flex-end" marginY="10px" gap="10px">
            {selectedCoverages.length > 0 && (
                <>
                    <Button 
                        size="medium" 
                        variant="outlined" 
                        color="success" 
                        onClick={() => setApproveModalOpen(true)}
                    >
                        <Typography variant="subtitle2">Approve</Typography>
                    </Button>
                    <Button 
                        size="medium" 
                        variant="outlined" 
                        color="error" 
                        onClick={() => setRejectModalOpen(true)}
                    >
                        <Typography variant="subtitle2">Reject</Typography>
                    </Button>
                    <Button 
                        size="medium" 
                        variant="outlined" 
                        color="warning" 
                        onClick={() => setDeleteModalOpen(true)}
                    >
                        <Typography variant="subtitle2">Delete</Typography>
                    </Button>
                </>
            )}

            {approveModalOpen && (
                <BulkApproveCoverageModal 
                    open={approveModalOpen} 
                    selectedRows={selectedCoverages} 
                    onClose={() => setApproveModalOpen(false)}
                    onSuccess={onSuccess}
                />
            )}
            {rejectModalOpen && (
                <BulkRejectCoverageModal 
                    open={rejectModalOpen} 
                    selectedRows={selectedCoverages} 
                    onClose={() => setRejectModalOpen(false)}
                    onSuccess={onSuccess}
                />
            )}
            {deleteModalOpen && (
                <BulkDeleteCoverageModal 
                    open={deleteModalOpen} 
                    selectedRows={selectedCoverages} 
                    onClose={() => setDeleteModalOpen(false)}
                    onSuccess={onSuccess}
                />
            )}
        </Box>
    );
};

export default CoverageGridActions;
